import React from 'react';
import PropTypes from 'prop-types';

import {Stack, TextField, Typography} from 'views/components';
import {Translate, translate} from 'views/module';

const PlaybooksNewPrompt = (props) => {
  const {playbookDescription, setPlaybookDescription} = props;

  return (
    <Stack sx={{gap: '8px'}}>
      <Typography
        sx={{
          fontSize: '12px',
          fontWeight: 600,
          color: '#A8A49E',
          lineHeight: '100%',
          textTransform: 'uppercase',
        }}
      >
        <Translate expression='playbooks.New.DescriptionLabel' />
      </Typography>
      <TextField
        value={playbookDescription}
        onChange={setPlaybookDescription}
        placeholder={translate('playbooks.New.DescriptionPlaceholder')}
        multiline
        minRows={5}
        maxRows={8}
        sx={{
          '& .MuiOutlinedInput-root': {
            'borderRadius': '12px',
            'backgroundColor': '#FFFFFF',
            'alignItems': 'flex-start',
          },
          '& .MuiOutlinedInput-input': {
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: '150%',
            color: '#1A1916',
            boxSizing: 'border-box',
          },
          '& .MuiOutlinedInput-input::placeholder': {
            color: '#A8A49E',
            opacity: 1,
            whiteSpace: 'pre-line',
          },
        }}
      />
    </Stack>
  );
};

PlaybooksNewPrompt.propTypes = {
  playbookDescription: PropTypes.string.isRequired,
  setPlaybookDescription: PropTypes.func.isRequired,
};

export default React.memo(PlaybooksNewPrompt);
